import React from 'react';
import styled from '@emotion/styled';
import { gridSize } from '@atlaskit/theme';
import { useAppSelector } from '../../../stores/redux.store';
import { useRegisterComponent } from '../../orchestrator';
import { useMarketingConsentContext } from '../contexts/LoginMarketingConsentContext';
import MarketingConsentCheckbox from '../../../components/MarketingConsentCheckbox';

const StyledMarketingConsentWrapper = styled.div`
  padding-top: ${gridSize() * 2}px;
`;

export const LoginMarketingConsent = () => {
  useRegisterComponent(LoginMarketingConsent.name);

  const config = useAppSelector(state => state.marketingConsent?.config);
  const isUsernameChecked = useAppSelector(state => state.login?.isUsernameChecked);
  const isV2UsernameChecked = useAppSelector(state => state.login?.isV2UsernameChecked);

  const { setMarketingConsent } = useMarketingConsentContext();

  if (!isUsernameChecked && !isV2UsernameChecked) {
    return null;
  }

  return (
    <StyledMarketingConsentWrapper>
      <MarketingConsentCheckbox config={config} onConsentChange={setMarketingConsent} />
    </StyledMarketingConsentWrapper>
  );
};
